export default __webpack_public_path__ + "static/media/logo-placeholder.0afbfbbd.webp";